import { render, staticRenderFns } from "./AdditionalFieldsTable.vue?vue&type=template&id=f3f67c2e&scoped=true&"
import script from "./AdditionalFieldsTable.vue?vue&type=script&lang=js&"
export * from "./AdditionalFieldsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFieldsTable.vue?vue&type=style&index=0&id=f3f67c2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f67c2e",
  null
  
)

export default component.exports